<form [formGroup]="backgroundForm">
    <app-title [objetives]="true" [disable]="disable" (onSubmitEvent)='onSubmit()' (editEvent)='edit()'></app-title>
    <app-objetives
        (emptyEvent)="emptyObjetives($event)"
        (saveObjetivesEditEvent)="saveObjetivesEditEvent($event)"
        [disable]="disable"
        [objetives]="objetives">
    </app-objetives>

    <p class="subtitle1" *ngIf="objetivesEmpty || !objetivosHasContent">
        {{'planes.objetivesPopup.emptyObjetives' | translate}}
    </p>
</form>